import LayoutUtils from 'src/utils/layout_utils';

/**
 * Sync visibility of dropdown and bedrooms subquestions based on parent question's value.
 */
export function syncQuestionSubquestions(questionBlock, parentQuestionId, parentValue) {
  if (!questionBlock || !parentQuestionId) {
    return;
  }

  const normalizedParentValue = (parentValue || '').toString().trim();

  questionBlock.querySelectorAll(`.js-showing-view-dropdown-subquestion[data-parent-question-id="${parentQuestionId}"]`).forEach((subquestion) => {
    const expectedValue = (subquestion.dataset.parentValue || '').trim();
    const shouldShow = normalizedParentValue !== '' && expectedValue === normalizedParentValue;
    LayoutUtils.toggle(subquestion, shouldShow);
  });

  questionBlock.querySelectorAll(`.js-showing-view-bedrooms-subquestion[data-parent-question-id="${parentQuestionId}"]`).forEach((subquestion) => {
    const shouldShow = normalizedParentValue !== '';
    LayoutUtils.toggle(subquestion, shouldShow);
  });
}
